import { Box, Skeleton, Text } from '@salestrak/ui'
import { InfoTooltip } from './InfoTooltip'
import { DrilldownMemberTag } from './DrilldownGroupTitle'
import { formatDateTime } from '#app/lib/utils/format-date'
import type { DashboardLabels, LatestKnockEntry } from '#app/lib/data'
const SKELETON_ROW_CLASS = 'h-5 w-full'

interface LatestKnockActivityProps {
  entries: LatestKnockEntry[] | null | undefined
  labels: DashboardLabels | null | undefined
}

export function LatestKnockActivity({ entries, labels }: LatestKnockActivityProps) {
  const loading = !entries

  return (
    <Box rounded="xl" border padding="md" surface="card">
      <Box direction="row" gap="xs" align="center">
        <Text size="sm" weight="medium" variant="muted">Latest {labels?.contactVerb ? `${labels.contactVerb.charAt(0).toUpperCase()}${labels.contactVerb.slice(1)}s` : ''}</Text>
        <InfoTooltip>
          Most recent {labels?.contactVerb} per rep, sorted by time of day.
        </InfoTooltip>
      </Box>
      <Box paddingTop="sm">
        <Box direction="column" gap="xs">
          {loading ? (
            Array.from({ length: 5 }, (_, i) => (
              <Skeleton key={i} className={SKELETON_ROW_CLASS} />
            ))
          ) : entries.length === 0 ? (
            <Text size="sm" weight="medium">No data</Text>
          ) : (
            entries.map((a, i) => (
              <Box direction="row" key={`${a.userId}-${i}`} justify="between" align="center">
                <DrilldownMemberTag userId={a.userId} name={a.name} size="sm" weight="regular" />
                <Text size="xs" variant="muted">{formatDateTime(a.creationDate)}</Text>
              </Box>
            ))
          )}
        </Box>
      </Box>
    </Box>
  )
}
